import { FC, ReactNode, MouseEventHandler } from 'react'
import cns from 'classnames'
import { ReactSVG } from 'react-svg'

interface Props {
  className?: string
  children: ReactNode
  onClick: MouseEventHandler<HTMLButtonElement>
}

const BtnShare: FC<Props> = ({ children, className = '', onClick }) => {
  return (
    <button
      className={cns('btn-share', className)}
      type="button"
      onClick={onClick}
    >
      <ReactSVG
        className="btn-share__icon"
        src={'/i/svg/share.svg'}
        wrapper="span"
      />
      <span className="btn-share__label">{children}</span>
    </button>
  )
}

export default BtnShare
